import { useState } from "react";
import { Menu } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { MobileMenu } from "@/components/MobileMenu";
import { useIsMobile } from "@/hooks/use-mobile";
import { cn } from "@/lib/utils";

export function MobileHeader() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const isMobile = useIsMobile();

  // Only show on mobile
  if (!isMobile) return null;

  return (
    <>
      {/* Fixed Mobile Header - ChatGPT Style with Safe Area */}
      <div className="md:hidden fixed top-0 left-0 right-0 bg-background/95 backdrop-blur-xl border-b border-border/50 z-40 flex items-center px-4 pt-[env(safe-area-inset-top)] transition-all duration-300" style={{ height: 'calc(60px + env(safe-area-inset-top))' }}>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          className={cn(
            "p-0 h-10 w-10 rounded-lg bg-card hover:bg-muted border border-border/60 transition-all duration-200 flex items-center justify-center",
            mobileMenuOpen && "bg-muted"
          )}
        >
          <Menu className="w-5 h-5 text-foreground" strokeWidth={2} />
        </Button>
        <div className="flex-1 flex justify-center items-center gap-1.5">
          <span className="font-semibold text-[17px] tracking-tight">Tax.GBT</span>
          <Badge variant="secondary" className="text-[9px] px-1.5 py-0">BETA</Badge>
        </div>
        <div className="w-10" /> {/* Spacer for centering */}
      </div>

      {/* Spacer to prevent content from hiding under fixed header - only on mobile */}
      <div className="md:hidden transition-all duration-300" style={{ height: 'calc(60px + env(safe-area-inset-top))' }} />

      {/* Mobile Menu Sidebar */}
      <MobileMenu isOpen={mobileMenuOpen} onClose={() => setMobileMenuOpen(false)} />
    </>
  );
}
